import ButtonState.Down
import ButtonState.Up
import game.CgaColor
import game.Game
import game.controller.Component
import view.Terminal

enum class ButtonState {
    Up,
    Down,
}

typealias ButtonEvent = (Game) -> Unit

class Button(text: String, col: Int, row: Int, width: Int, height: Int) :
    Component(text, col, row, width, height) {
    var onDown: ButtonEvent = {}
    var onUp: ButtonEvent = {}
    var onClick: ButtonEvent = {}

    private var state = Up

    override fun render(game: Game, terminal: Terminal) {
        val highlightColor = when (state) {
            Up -> CgaColor.WHITE
            Down -> CgaColor.LIGHT_GRAY
        }
        val shadowColor = when (state) {
            Up -> CgaColor.LIGHT_GRAY
            Down -> CgaColor.WHITE
        }
        val backgroundColor = CgaColor.BLACK

        terminal.drawSingleHLine(top, left, right, highlightColor, backgroundColor)
        terminal.drawSingleHLine(bottom, left, right, shadowColor, backgroundColor)
        terminal.drawSingleVLine(left, top, bottom, highlightColor, backgroundColor)
        terminal.drawSingleVLine(right, top, bottom, shadowColor, backgroundColor)

        terminal.setChar(left, top, 0xDA, highlightColor, backgroundColor)
        terminal.setChar(left, bottom, 0xC0, highlightColor, backgroundColor)
        terminal.setChar(right, top, 0xBF, highlightColor, backgroundColor)
        terminal.setChar(right, bottom, 0xD9, shadowColor, backgroundColor)

        terminal.drawStringCentered(
            left + 1,
            top + ((bottom - top) / 2),
            right - 1,
            text,
            CgaColor.LIGHT_GRAY,
            backgroundColor
        )
    }

    override fun down(game: Game) {
        state = Down
        onDown(game)
    }

    override fun up(game: Game) {
        state = Up
        onUp(game)
    }

    override fun click(game: Game) {
        onClick(game)
    }
}

